import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { RestoreConnectionArgs } from '../../../Domain/Admin/Services';
import { adminServices } from '../../../Domain/Admin/Services';

const mutationFn = (data: RestoreConnectionArgs) => {
  return adminServices.restoreConnection(data);
};

export const useRestoreConnectionMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<unknown, unknown, RestoreConnectionArgs>(mutationFn, {
    onSuccess: () => {
      queryClient.invalidateQueries(['getDeletedConnections']);
    },
  });
};
